import { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

// import Loader from '../../Loader/Loader';
import Backdrop from '../../Backdrop/Backdrop';
import Modal from '../../Modal/Modal';
import { useStore } from '../../../hook-store/store';

import { watakuraPageLink } from '../../../App';
import { marks } from '../../../utils/marks';

import classes from './GroupTalkInfo.module.css';

import GroupTalkImage from '../../../images/groupTalkInfo/group-file-share-h150.jpeg';
import GroupTalkImage2 from '../../../images/groupTalkInfo/cloud-sync-crop-h150.png';


function GroupTalkInfo(props) {
  const { } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { gLoading } = store.uiStore;

  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    if (gLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  },[gLoading]);

  const groupTalkLink = (
    <a href={`${watakuraPageLink}`}
      target="_blank" rel="noopener noreferrer"
    >
      {t('groupTalkInfo01', 'Group Talk')}
      {' '}(Group chat)
    </a>
  );

  // const bookRemeetLink = (
  //   <a href={`https://bookremeet.spaceeight.net`}
  //     target="_blank" rel="noopener noreferrer"
  //   >
  //     reservation page
  //   </a>
  // );

  let groupTalkInfoBody;

  groupTalkInfoBody = (
    <div>
      <div className={classes.groupTalkInfoTitle}>
        {t('groupTalkInfo02', 'Group Talk for file sharing and communication with other users')}
      </div>
      <p className={classes.groupTalkInfoImages}>
        <img className={classes.groupTalkInfoImage}
          src={GroupTalkImage}
        />
        <img className={classes.groupTalkInfoImage}
          src={GroupTalkImage2}
        />
      </p>

      <p>
        {groupTalkLink}{' '}
        {t('groupTalkInfo03', 'is a tool for file sharing and chat communication. User can share files in this page, and communicate with other users by text chat.')}
      </p>

      <p>
        {t('groupTalkInfo04', 'After group creation, group creator can invite many other users to the group for file sharing and text talk.')}
      </p>

      <p>
        {t('groupTalkInfo05', 'Files can be shared from file action in this page.')}
      </p>
      
      <p>
        {groupTalkLink}{' '}
        {t('groupTalkInfo06', 'is useful for working about files with other users.')}
      </p>

    </div>
  );

  return (
    <Fragment>
      <Backdrop 
        onCancel={() => {
          if (!isLoading) {
            dispatch('SET_SHOWGROUPTALKINFO', false);
          }
        }}
      />
      <Modal
        hideButtons={true}
        onClose={() => {
          if (!isLoading) {
            dispatch('SET_SHOWGROUPTALKINFO', false);
          }
        }}
      >
        {groupTalkInfoBody}
      </Modal>
    </Fragment>
  );
}

export default GroupTalkInfo;
